import React from 'react';
import PropTypes from 'prop-types';
import styles from './NumberedCard.css';

const NUMBER_LENGTH = 2;

function NumberedCard({ number, title, description }) {
    return (
        <li className={styles.root}>
            <span className={styles.number}>{String(number).padStart(NUMBER_LENGTH, '0')}</span>
            <div className={styles.content}>
                <h3 className={styles.title}>{title}</h3>
                <p className={styles.description}>{description}</p>
            </div>
        </li>
    );
}

NumberedCard.propTypes = {
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

export {
    NumberedCard
};
